/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalTimer_viewer = {
    readonly actualPersonId: string | null;
    readonly timerStartDate: string | null;
    readonly timerEndDate: string | null;
    readonly timerTask: {
        readonly id: string;
    } | null;
    readonly " $refType": "TimeRegistrationModalTimer_viewer";
};
export type TimeRegistrationModalTimer_viewer$data = TimeRegistrationModalTimer_viewer;
export type TimeRegistrationModalTimer_viewer$key = {
    readonly " $data"?: TimeRegistrationModalTimer_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationModalTimer_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalTimer_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerEndDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "timerTask",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '56433041a4a684d3d293757c55d1696e';
export default node;
